import { DateTime } from 'luxon';

export class BrokerageDates {
  pickupTimeZone: string = 'system';
  pickupEarliest?: DateTime;
  pickupLatest?: DateTime;
  deliveryTimeZone: string = 'system';
  deliveryEarliest?: DateTime;
  deliveryLatest?: DateTime;

  constructor(opts?: Partial<BrokerageDates>) {
    if (opts?.pickupTimeZone) {
      this.pickupTimeZone = opts.pickupTimeZone;
    }

    this.pickupEarliest = opts?.pickupEarliest;

    this.pickupLatest = opts?.pickupLatest;

    if (opts?.deliveryTimeZone) {
      this.deliveryTimeZone = opts.deliveryTimeZone;
    }

    this.deliveryEarliest = opts?.deliveryEarliest;

    this.deliveryLatest = opts?.deliveryLatest;
  }
}
